import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedService } from '../../../shared/shared.service';
import { API_MODULES } from '../../../core/api-modules';

@Component({
  selector: 'app-brand-slug',
  templateUrl: './brand-slug.component.html',
  styleUrls: ['./brand-slug.component.scss']
})
export class BrandSlugComponent implements OnInit {
  products: any[] = [];
  loading: boolean = false;

  constructor(
    private api: SharedService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    const slug = this.route.snapshot.paramMap.get('slug');
    if (slug) {
      this.loadProducts(slug);
    } else {
      // If no slug, fall back to all products or redirect
      this.router.navigate(['/brand']);
    }
  }

  async loadProducts(slug: string): Promise<void> {
    try {
      this.loading = true;
      const encoded = encodeURIComponent(slug);
      const res: any = await this.api.get(`product/list?brand_slug=${encoded}`);
      if (res?.status === 'success' && res?.data) {
        this.products = res.data;
      }
    } catch (error) {
      console.error('Error loading products:', error);
    } finally {
      this.loading = false;
    }
  }

  getImg(path: string): string {
    if (!path) {
      return 'assets/no-image.png';
    }
    // If path already starts with http/https, return as is
    if (path.startsWith('http://') || path.startsWith('https://')) {
      return path;
    }
    // Otherwise, append to base URL
    return this.api.imageBase + path;
  }

  viewProduct(slugs: string): void {
    this.router.navigate(['/products-details', slugs]);
  }
}
